import ApiService from "../../../common/api.service";
import { Message } from "element-ui";

export async function GetPPN({ commit }, option) {
  try {
    ApiService.init("heroku");
    commit("PPN_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.query("/v1/tax", option);// get /?limit=1 query
    commit("PPN_SUCCESS", _response.data);
  } catch (error) {
    commit("PPN_ERROR", { result: error.message });
  }
}

export async function UpdatePPN({ commit }, form) {
  try {
    ApiService.init("heroku");
    commit("UPDATE_PPN_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.put("/v1/tax", form);// put post
    Message({
      message: "Updated completed",
      type: "success"
    });
    commit("UPDATE_PPN_SUCCESS", _response.data);
  } catch (error) {
    commit("UPDATE_PPN_ERROR", { result: error.message });
  }
}
